import Vue from 'vue'
import HttpService from '@/services/http.service'
import { VueMasonryPlugin } from 'vue-masonry'
import VueFroala from 'vue-froala-wysiwyg'

Vue.use(VueFroala)

Vue.use(HttpService)
Vue.use(VueMasonryPlugin)
